<template>
    <button v-if="isTrainer" type="button" class="zapping-pill"
        :class="{ 'zapping-pill--light': !isDark, 'zapping-pill--locked': locked }" @click="onClick">
        <v-icon size="14">{{ locked ? 'mdi-lock-outline' : 'mdi-flash' }}</v-icon>
        {{ $t('common.zapping') }}
    </button>
</template>

<script>
export default {
    name: 'ZappingButton',
    computed: {
        isDark(vm = this) {
            return vm.$vuetify.theme.dark
        },
        isTrainer(vm = this) {
            return ['coach', 'company'].includes(vm.accountType)
        },
        locked(vm = this) {
            return !vm.can('zapping')
        }
    },
    methods: {
        onClick() {
            const vm = this
            if (!vm.requirePlan('zapping')) return
            vm.$router.push({ name: `${vm.accountType}.zapping` })
        }
    }
}
</script>

<style scoped>
.zapping-pill {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    white-space: nowrap;
    gap: 7px;
    background: linear-gradient(135deg, rgba(204, 255, 51, 0.15), rgba(51, 153, 153, 0.15));
    color: var(--v-primary-base);
    border: 1px solid rgba(204, 255, 51, 0.35);
    font-family: inherit;
    font-size: 13px;
    font-weight: 700;
    border-radius: 8px;
    padding: 9px 16px;
    cursor: pointer;
    letter-spacing: -0.01em;
    transition: opacity .15s ease, transform .15s ease, border-color .15s ease;
}

.zapping-pill:hover {
    opacity: 0.9;
    transform: translateY(-1px);
    border-color: rgba(204, 255, 51, 0.6);
}

.zapping-pill ::v-deep .v-icon {
    color: var(--v-primary-base) !important;
}

.zapping-pill.zapping-pill--locked {
    background: var(--v-surface2-base);
    color: var(--v-txtMuted-base);
    border-color: var(--v-outline-base);
}

.zapping-pill.zapping-pill--locked ::v-deep .v-icon {
    color: var(--v-txtMuted-base) !important;
}

.zapping-pill--light {
    background: rgba(51, 153, 153, 0.1);
    color: var(--v-accent-base);
    border-color: rgba(51, 153, 153, 0.35);
}

.zapping-pill--light ::v-deep .v-icon {
    color: var(--v-accent-base) !important;
}

.zapping-pill--light:hover {
    background: rgba(51, 153, 153, 0.16);
    border-color: rgba(51, 153, 153, 0.6);
}

@media (max-width: 599px) {
    .zapping-pill {
        padding: 8px 12px;
        font-size: 12px;
    }
}
</style>

